import { StoryblokRichtext, type StoryblokRichTextData } from '../../../../richtext';
import {
  type FontFamily,
  type SBProps,
  type Spacing,
  type TextAlign,
  resolveStoryblokStyles,
  sbEditable,
} from '../../../../utils';

interface SBRichtextProps {
  content?: StoryblokRichTextData;
  textAlignMobile?: TextAlign;
  textAlignTablet?: TextAlign;
  textAlignDesktop?: TextAlign;
  fontFamily?: FontFamily;
  mtMobile?: Spacing;
  mtTablet?: Spacing;
  mtDesktop?: Spacing;
  mbMobile?: Spacing;
  mbTablet?: Spacing;
  mbDesktop?: Spacing;
  parentProps?: {
    className?: string;
  };
}

export const SBRichtext = ({ blok }: SBProps<SBRichtextProps>) => {
  const {
    content,
    textAlignMobile,
    textAlignTablet,
    textAlignDesktop,
    fontFamily,
    mtMobile,
    mtTablet,
    mtDesktop,
    mbMobile,
    mbTablet,
    mbDesktop,
    parentProps,
  } = blok;

  const className = resolveStoryblokStyles({
    textAlign: textAlignMobile,
    textAlignTablet,
    textAlignDesktop,
    fontFamily,
    mt: mtMobile,
    mtTablet,
    mtDesktop,
    mb: mbMobile,
    mbTablet,
    mbDesktop,
    className: parentProps?.className,
  });

  return <StoryblokRichtext className={className} data={content} {...sbEditable(blok)} />;
};
